import { ReactElement } from 'react';

import useSettings from '../../hooks/useSettings';

type Props = {
    formSE: ReactElement;
    formNO: ReactElement;
    formDK: ReactElement;
};

/**
 * The switcharoo component will switch between components depending on country code.
 */
const Switcharoo = ({ formSE, formNO, formDK }: Props) => {
    const { countryCode } = useSettings();
    switch (countryCode) {
        case 'NO':
            return formNO;
        case 'DK':
            return formDK;
        default:
            return formSE;
    }
};

export default Switcharoo;
